import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { Action, ActionReducer, provideStore } from '@ngrx/store';
import { IAuthenticationState, authenticationReducer } from '../shared/auth/authentication.reducer';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { localStorageSyncReducer } from '../shared/meta-reducers/local-storage-sync.reducer';
import { provideEffects } from '@ngrx/effects';
import { AuthenticationEffects } from '../shared/auth/authentication.effects';
import { AppConfigurationEffects } from '../shared/app-configuration/app-configuration.effects';
import { IAppConfigurationState, appConfigurationReducer } from '../shared/app-configuration/app-configuration.reducer';
import { INavigation, navigationReducer } from '../shared/navigation/navigation.reducer';
import { loadingInterceptor } from '../shared/interceptors/loading.interceptor';
import { FreightPayerEffects } from '../shared/freight-payers/freight-payer.effects';
import { IFreightPayerState, freightPayerReducer } from '../shared/freight-payers/freight-payer.reducer';
import { IProductState, productReducer } from '../shared/products/products.reducer';
import { ProductsEffects } from '../shared/products/products.effects';
import { IMasterContactState, masterContactReducer } from '../shared/master-contact/master-contact.reducer';
import { MasterContactEffects } from '../shared/master-contact/master-contact.effects';
import { OrderEffects } from '../shared/orders/order.effects';
import { IOrdersState, orderReducer } from '../shared/orders/order.reducer';
import { IBryntumGridState, bryntumGridReducer } from '../shared/bryntum/bryntum-grid-state.reducer';
import { BryntumGridStateEffects } from '../shared/bryntum/bryntum-grid-state.effects';
import { logoutClearStateReducer } from '../shared/meta-reducers/logout-clear-state.reducer';
import { provideAnimations } from '@angular/platform-browser/animations';
import { IUserConfiguration, userReducer } from '../shared/user/user.reducer';
import { UserEffects } from '../shared/user/user.effects';
import { ContainerSearchReducer, IContainerSearchState } from '../shared/Container/container.reducer';

export interface IRootState {
  AuthenticationState: ActionReducer<IAuthenticationState, Action<string>>;
  FreightPayerState: ActionReducer<IFreightPayerState, Action<string>>;
  ProductState: ActionReducer<IProductState, Action<string>>;
  MasterContactState: ActionReducer<IMasterContactState, Action<string>>;
  AppConfigurationState: ActionReducer<IAppConfigurationState, Action<string>>;
  NavigationState: ActionReducer<INavigation, Action<string>>;
  OrderState: ActionReducer<IOrdersState, Action<string>>;
  BryntumGridState: ActionReducer<IBryntumGridState, Action<string>>;
  UserState: ActionReducer<IUserConfiguration, Action<string>>;
  ContainerSearchState: ActionReducer<IContainerSearchState, Action<string>>;
}

export const appStoreConfig: IRootState = {
  AuthenticationState: authenticationReducer,
  FreightPayerState: freightPayerReducer,
  AppConfigurationState: appConfigurationReducer,
  NavigationState: navigationReducer,
  ProductState: productReducer,
  MasterContactState: masterContactReducer,
  OrderState: orderReducer,
  BryntumGridState: bryntumGridReducer,
  UserState: userReducer,
  ContainerSearchState: ContainerSearchReducer
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideStore(appStoreConfig, { metaReducers: [localStorageSyncReducer, logoutClearStateReducer] }),
    provideEffects([
      AuthenticationEffects,
      AppConfigurationEffects,
      FreightPayerEffects,
      ProductsEffects,
      MasterContactEffects,
      OrderEffects,
      BryntumGridStateEffects,
      UserEffects,
    ]),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([loadingInterceptor])),
    provideStoreDevtools({ maxAge: 25 }),
    provideAnimations()
  ]
};
